module.exports = __webpack_public_path__ + "static/Contact_Mobile_highres-0a39ce37b2a8f486a1c1ed868d33c36f.jpg";